<template>
  <v-expand-transition>
    <div class="warnings-vincols" v-if="getBet.warnings.length > 0 && getBet.odds.length > 0">
      <!--    <div class="messages">-->
      <!--      Warnings-->
      <!--    </div>-->
      <v-alert dense text type="warning" v-for="(warning, index) in getBet.warnings" :key="$uuid.v1()" style="padding: 5px;">
        {{$t(warning.message)}} <br/>
        <span v-if="warning.message == 'max_winning_reached'">{{ getSettings.currencySymbol }} {{warning.value}}</span>
        <span v-if="warning.message == 'max_odds_reached'">x {{warning.value}}</span>
      </v-alert>
      <!--    <div class="messages" v-for="(warning, index) in getBet.warnings" :key="index">-->
      <!--      - {{ $t(warning.message)}}-->
      <!--    </div>-->
    </div>
  </v-expand-transition>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'Warnings',
  data: () => ({}),
  computed: {
    ...mapGetters({
      'getBet': 'cart/getBet',
      'getSettings': 'cart/getSettings',
    }),

  },
  methods: {
    ...mapActions({}),

  },


};
</script>